import { useState } from 'react'

import { BlockReasonModal, BlockSubmitModal, BlockConfirmationModal } from './steps'

/**
 * Container for the block-invitee flow (reason → submit → success).
 *
 * @param {Object} props
 * @param {Object} props.event - The event for this invitee. Required; must have at least `past` for the success step.
 * @param {boolean} [props.event.past] - Whether the event is in the past (used for confirmation copy).
 * @param {Object} props.invitee - The invitee being blocked. Must have `uuid`, `name`, `email`.
 * @param {() => void} props.onClose - Called when the modal is closed.
 * @param {() => void} [props.onBlockSuccess] - Called after a successful block (e.g. to refresh UI).
 */
export const BlockModal = ({ event, invitee, onClose, onBlockSuccess }) => {
  const [step, setStep] = useState('reason')
  const [reason, setReason] = useState('')
  const [reasonType, setReasonType] = useState('')

  const onChooseReason = (value, key) => {
    setReason(value)
    setReasonType(key)
    setStep('submit')
  }

  if (step === 'reason') {
    return (
      <BlockReasonModal
        onClose={onClose}
        onChooseReason={onChooseReason}
        inviteeName={invitee.name}
      />
    )
  }

  if (step === 'submit') {
    return (
      <BlockSubmitModal
        event={event}
        invitee={invitee}
        reason={reason}
        reasonType={reasonType}
        onClose={onClose}
        onSuccess={() => setStep('success')}
        onBack={() => setStep('reason')}
      />
    )
  }

  if (step === 'success') {
    return <BlockConfirmationModal onClose={onClose} onBlockSuccess={onBlockSuccess} isPast={event.past} />
  }

  return null
}
